<template>
  <div>
    <div class="max-w-5xl mx-auto space-y-16">
      <div class="flex items-center justify-between">
        <h4 class="text-indigo-500 capitalize">
          {{ $te('packageItems') ? $t('packageItems') : 'packageItems' }}
        </h4>
        <RouterLink
          :to="{ name: 'admin.products.packages.package.packageItems.create' }"
          class="btn btn-brand px-6 capitalize"
        >
          {{ $te('addPackageItem') ? $t('addPackageItem') : 'addPackageItem' }}
        </RouterLink>
      </div>
      <DataIterat
        :headless="fetching"
        actionable
        with-base-filters
        v-bind="{ items: sortedAndGroupedPackageItems, loading: fetching }"
        v-on="{ getData: doGetPackageItems }"
      >
        <DataIteratHeaderContent slot="list-header-content" />
        <DataIteratItemContent
          slot="list-item-content"
          slot-scope="{ dataItem }"
          v-bind="{ packageItem: dataItem }"
        />
        <DataIteratItemActions
          slot="list-item-actions"
          slot-scope="{ dataItem, onClick }"
          v-bind="{ packageItem: dataItem }"
          v-on="{ actionClicked: onClick }"
        />
      </DataIterat>
      <div>
        <RouterView name="modal" />
      </div>
    </div>
  </div>
</template>

<script>
import { groupBy, flatMap } from 'lodash-es';
import { packageItemMethods, packageItemComputed } from '@/store/adminHelper';
import DataIterat from '@/components/Ui/DataIterat.vue';
import DataIteratHeaderContent from '@/components/PackageItem/DataIteratHeaderContent.vue';
import DataIteratItemContent from '@/components/PackageItem/DataIteratItemContent.vue';
import DataIteratItemActions from '@/components/PackageItem/DataIteratItemActions.vue';

export default {
  name: 'PackageItemList',
  components: {
    DataIterat,
    DataIteratItemContent,
    DataIteratHeaderContent,
    DataIteratItemActions,
  },
  props: {
    packageId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...packageItemComputed,
    sortedPackageItems() {
      return this.packageItems.slice(0).sort((a) => (!a.optional ? -1 : 1));
    },
    sortedAndGroupedPackageItems() {
      return flatMap(
        // Group Related Items (Item + Upgrades go together)
        groupBy(this.sortedPackageItems.slice(0), (cur) => cur.upgradesPackageItemId || cur.id),
        // Flat
        (cur) => cur
      );
    },
  },
  destroyed() {
    this.setIds([]);
  },
  methods: {
    ...packageItemMethods,
    doGetPackageItems(queryParams) {
      this.fetching = true;
      const { packageId } = this;
      this.getPackageItems({ packageId, queryParams })
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
  },
};
</script>
